import { ShieldAlert } from "lucide-react";

export const DisclaimerBanner = () => (
  <div
    data-testid="disclaimer-banner"
    className="fixed top-0 inset-x-0 z-50 bg-brand-warning text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium tracking-wide shadow-md"
  >
    <ShieldAlert className="w-4 h-4 shrink-0" />
    <span>PROTOTIPO — no usar con datos reales de pacientes</span>
  </div>
);
